import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../../data/site';

/** Original logo, unaltered, presented on a light chrome plate for contrast on dark backgrounds. */
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <Link to="/" aria-label="Homeland Personal Protection — home" className={`chrome-plate inline-flex shrink-0 items-center rounded-[4px] px-2.5 py-1.5 ring-1 ring-white/40 ${className}`} data-id="element-546" data-mp="rtqh4rstu8sg">
      <img src={SITE.logo} alt="HPP Training — Homeland Personal Protection" width={300} height={95} className="h-9 w-auto lg:h-11" data-id="element-547" data-mp="dwbpdgf3poxb" />
    </Link>;
}